import React from 'react';
import Button from '../../../../generic-components/Button';
import Heading from '../../../../generic-components/Heading';
import { STYLES } from '../../consts';

interface IProps {
    periodPresets: {title: string, id: string}[]
    selectedPeriod: string;
    handlePeriodSelection: (id: string) => void;
}
export const PeriodPresetList = ({ periodPresets, selectedPeriod, handlePeriodSelection }: IProps) => (
  <ul className={STYLES.PERIOD_LIST}>
    {periodPresets.map(i => (
      <li className={`cursor-pointer ${i.id === selectedPeriod ? 'bg-action00' : ''} ${STYLES.PERIOD_LIST_ITEM}`}>
        <Button onClick={() => handlePeriodSelection(i.id)} className='' id={i.id} childElement={<Heading title={i.title} className={STYLES.PERIOD_LIST_ITEM_TITLE} />} />
      </li>
    ))}
  </ul>
);
